module.exports = __webpack_public_path__ + "assets/p_placeholder_img_profilo.d80e38f5.svg";